

import React from "react"
import './ViewEditBox.scss';
import { Grid } from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import FlexView from 'react-flexview'

export const ViewEditBox = (props) => {
    const { text, icon, editable = true, deleteable = false } = props
    let hasIcon = !!icon

    const onEdit = () => {
        props.onEdit && props.onEdit()
    }

    const onDelete = () => {
        props.onDelete && props.onDelete()
    }

    return (<div className="container">
                <Grid container justify="space-between" alignItems="center" spacing={hasIcon ? 2 : 3} style={{flexWrap: 'unset'}}>
                    {hasIcon && <Grid item>
                        <div className="icon-box">
                            <div className="icon-content-left">
                                {icon}
                            </div>
                        </div>
                    </Grid>}
                    <Grid item>
                        <div className={hasIcon ? "content" : "content-no-icon"}>
                            <div className="text-body darkbluegray">
                                {text}
                            </div>
                        </div>
                    </Grid>
                    {editable && <Grid item>
                        <FlexView vAlignContent={'center'} className="action-content-right">
                            <EditIcon onClick={onEdit} fontSize="small" className="clickable backbuttongray" />
                            {deleteable && <DeleteIcon onClick={onDelete} fontSize="small" className="clickable margin-left-12 backbuttongray" /> }
                        </FlexView>
                    </Grid>}
                </Grid>
            </div>)
}